// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__TZUGz","text":"Checkbox_text__xRkyG","checkbox":"Checkbox_checkbox__yfTeo","checked":"Checkbox_checked__2EhjV"};